import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Listingheader from '../../../../home/components/common/ListingheaderV2';
import HeaderTab from '../../../../home/components/desktop/HeaderTabV2/HeaderTab';
import PointsTable from '../PointsTable/PointsTable';
import PointsTableList from '../PointsTable/PointsTableList';
import s from './PointsTableWrapper.scss';
import InterSectionBorder from '../../../../../components_v2/common/InterSectionBorder/InterSectionBorder';

const PointsTableWrapper = props => {
  const {
    name = '',
    bordertop = '',
    borderbottom = '',
    hideTabs = '',
    className = '',
    hideFlags = '',
    isFifaPage = '',
    headerHeading,
    items = {},
  } =
    props.sectionItem || {};
  const standings = items?.standings;
  // eslint-disable-next-line no-shadow
  const setHeaderGroupTabs = standings => {
    if (standings === null || typeof standings === 'undefined') {
      return {};
    }
    const headerVal = Object.keys(standings);
    let tableGroupData;
    let headerTabData;
    if (headerVal.length > 0) {
      headerTabData = headerVal.map((tab, idx) => {
        let tabObj = {
          id: idx,
          name:
            standings[tab] && standings[tab]?.stage_type
              ? standings[tab]?.stage_type
              : tab,
          link: tab,
        };
        if (
          standings[tab]?.is_active &&
          standings[tab].is_active.toLowerCase() === 'true'
        ) {
          tabObj = {
            active: !!(
              standings[tab]?.is_active &&
              standings[tab].is_active.toLowerCase() === 'true'
            ),
            ...tabObj,
          };
          tableGroupData = standings[tab];
        }
        return tabObj;
      });
    }
    return { headerTabData, tableGroupData };
  };
  const { headerTabData, tableGroupData } = setHeaderGroupTabs(standings);
  const [pointTableData, setPointTableData] = useState(standings);
  const [headerTab, setHeaderTab] = useState(headerTabData);
  const [groupData, setGroupData] = useState(tableGroupData);
  const [selectedTab, setSelectedTab] = useState();
  const [teamData, setTeamData] = useState([]);

  // eslint-disable-next-line no-shadow
  const recievePointTableData = standings => {
    setPointTableData(standings);
    const { tabData, grpData } = setHeaderGroupTabs(standings);
    setGroupData(grpData);
    setHeaderTab(tabData);
  };

  useEffect(
    () => {
      if (
        groupData &&
        Object.keys(groupData).length > 0 &&
        groupData.groups &&
        Array.isArray(groupData.groups) &&
        groupData.groups.length > 0
      ) {
        const groupTeam = groupData.groups.filter(
          val => val.name === selectedTab,
        );
        setTeamData(groupTeam[0]);
      }
    },
    [selectedTab],
  );

  useEffect(
    () => {
      if (
        props?.ifFifaHomePageWidget &&
        props?.FifaData &&
        Object.keys(props?.FifaData).length > 0
      ) {
        recievePointTableData(props?.FifaData);
        if (props?.currentTab === 'Points Table') {
          setSelectedTab('A');
        } else {
          setSelectedTab('Group A');
        }
      }
      const element = document.getElementById(selectedTab);
      if (element) {
        element.scrollIntoView({ block: 'nearest', Inline: 'center' });
      }
    },
    [props?.FifaData],
  );

  const onHeaderTabsChange = dataObj => {
    if (
      dataObj?.clickedItem &&
      dataObj?.clickedItem?.link &&
      pointTableData &&
      pointTableData[dataObj.clickedItem.link]
    ) {
      setGroupData(pointTableData[dataObj.clickedItem.link]);
    }
  };

  const groupDataList =
    isFifaPage && items?.standings && items?.standings?.stage1
      ? items?.standings?.stage1
      : groupData;
  return (
    <>
      {!!bordertop && <InterSectionBorder />}
      {!props?.ifFifaHomePageWidget && (
        <div className={`${s.section_wrapper} ${className}`}>
          {!isFifaPage && (
            <Listingheader headingname={name}>
              {headerTab &&
                headerTab instanceof Array && (
                  <HeaderTab
                    subSections={headerTab}
                    onChangeCallback={onHeaderTabsChange}
                    // loading={this.state.loading}
                    // active={sectionData && sectionData.id === 'elections' && this.tabName}
                    // newga={`${sectionData.name}Section_TabChange#Click_`}
                  />
                )}
            </Listingheader>
          )}

          {groupDataList &&
            groupDataList?.groups &&
            Array.isArray(groupDataList?.groups) &&
            groupDataList?.groups.length > 0 && (
              <PointsTable
                groupData={groupDataList?.groups}
                hideTabs={hideTabs}
                hideFlags={hideFlags}
                isFifaPage={isFifaPage}
                currentTab={groupDataList?.groups[0]?.name}
                isWapView={props?.isWapView}
                headerHeading={headerHeading}
              />
            )}
          {groupDataList?.team &&
            Array.isArray(groupDataList?.team) && (
              <PointsTableList
                tabData={groupDataList}
                hideFlags={hideFlags}
                isFifaPage={isFifaPage}
                activeTab=""
                className={s.activeTab}
                isWapView={props.isWapView}
                headerHeading={headerHeading}
              />
            )}
        </div>
      )}
      {props?.ifFifaHomePageWidget && (
        <>
          <>
            <div className={`${s.fifaTab} fifaTab`}>
              {groupData &&
                groupData.groups &&
                Array.isArray(groupData.groups) &&
                groupData.groups.length > 0 &&
                groupData.groups.map((val, index) => (
                  <div
                    className={`${s.tabLink} ${
                      val.name === selectedTab ? s.active : ''
                    }`}
                    key={index}
                    onClick={() => setSelectedTab(val.name)}
                    id={selectedTab}
                  >
                    {props?.currentTab === 'Points Table' ? 'GROUP' : ''}{' '}
                    {val.name}
                  </div>
                ))}
            </div>
          </>
          <div className={`${s.tableWrapper} tableWrapper`}>
            <PointsTableList
              tabData={teamData}
              hideFlags={hideFlags}
              isFifaPage={props?.isFifaPage}
              activeTab=""
              className={s.activeTab}
              isWapView={props?.isWapView}
              headerHeading={props?.headerHeading}
              ifFifaHomePageWidget
              currentTab={props?.currentTab}
            />
          </div>
        </>
      )}
      {!!borderbottom && <InterSectionBorder />}
    </>
  );
};

PointsTable.propTypes = {
  sectionItem: PropTypes.objectOf({}),
  isWapView: PropTypes.bool,
  hideTabs: PropTypes.string,
  hideFlags: PropTypes.string,
  isFifaPage: PropTypes.string,
  headerHeading: PropTypes.arrayOf({}),
  ifFifaHomePageWidget: PropTypes.bool,
  FifaData: PropTypes.objectOf({}),
  fifaData: PropTypes.arrayOf({}),
  currentTab: PropTypes.string,
};
PointsTable.defaultProps = {
  sectionItem: {},
  isWapView: false,
  hideTabs: '',
  hideFlags: '',
  isFifaPage: '',
  headerHeading: [],
  ifFifaHomePageWidget: false,
  FifaData: {},
  fifaData: [],
  currentTab: '',
};

export default React.memo(PointsTableWrapper);
